import React from "react";
import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  ImageSourcePropType,
  ImageBackground,
} from "react-native";
import { useTranslation } from "react-i18next";
import { BuyBtn, BuyVipBtn, VipBackground } from "../../../../assets";
import { Package } from "../../../../store/types";

type VipCardProps = {
  vipIcon: ImageSourcePropType;
  borderColor: string;
  textColor: string;
  vipLabel: ImageSourcePropType;
  price: number;
  name: string;
  pkg: Package;
  onPayment: (packageItem: Package) => void;
};

const VipCard = ({
  vipIcon,
  textColor,
  vipLabel,
  borderColor,
  price,
  name,
  pkg,
  onPayment,
}: VipCardProps) => {
  const { t } = useTranslation();

  const monthMatch = name?.match(/^(\d+)\s+month/i);
  let translatedName = name;
  if (monthMatch) {
    const count = Number(monthMatch[1]);
    const key = count === 1 ? "T_SITE_SHOP_MONTH" : "T_SITE_SHOP_MONTHS";
    translatedName = `${count} ${t(key)}`;
  }
  const handleBuyPress = () => {
    onPayment(pkg);
  };
  return (
    <ImageBackground
      source={VipBackground}
      resizeMode="stretch"
      style={styles.background}
    >
      <View style={styles.card}>
        <View style={styles.left}>
          <Image
            source={vipIcon}
            style={styles.vipImage}
            resizeMode="contain"
          />
        </View>

        <View style={styles.right}>
          <View style={styles.labelRow}>
            <Text style={[styles.month, { color: textColor }]}>
              {translatedName}
            </Text>
            <Image
              source={vipLabel}
              style={styles.vipLabel}
              resizeMode="contain"
            />
          </View>
          <Text style={styles.price}>{price}€</Text>

          <TouchableOpacity
            style={styles.buyNowButton}
            onPress={handleBuyPress}
          >
            {/* <Image
              source={BuyBtn}
              style={styles.buyNowBtn}
              resizeMode="contain"
            /> */}
            <ImageBackground
              source={BuyVipBtn}
              style={styles.buyNowBtn}
              resizeMode="contain"
            >
              <Text style={styles.text}>{t("T_SITE_BUY_VIP")}</Text>
            </ImageBackground>
          </TouchableOpacity>
        </View>
      </View>
    </ImageBackground>
  );
};

export default VipCard;

const styles = StyleSheet.create({
  background: {
    width: "100%",
    paddingHorizontal: 0,
  },
  card: {
    flexDirection: "row",
    alignItems: "center",
  },
  left: {
    flex: 1,
    alignItems: "center",
  },
  right: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: 12,
  },
  text: {
    fontSize: 15,
    fontWeight: "700",
    letterSpacing: 0.6,
    color: "#FFFFFF",
    textShadowColor: "rgba(0, 0, 0, 0.98)",
    textShadowOffset: { width: 0, height: 3 },
    textShadowRadius: 4,
    textTransform: "uppercase",
    textAlign: "center",
    paddingTop: 12,
  },
  labelRow: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 8,
  },
  vipImage: {
    width: 200,
    height: 132,
  },
  vipLabel: {
    width: 40,
    height: 30,
  },
  month: {
    fontSize: 20,
    fontWeight: "900",
    marginLeft: 8,
    marginTop: 4,
  },
  price: {
    fontSize: 24,
    fontWeight: "500",
    color: "#fff",
    textAlign: "center",
    marginVertical: 12,
    textShadowColor: "#000",
    textShadowOffset: { width: 1, height: 2 },
    textShadowRadius: 3,
    letterSpacing: 1,
    textTransform: "uppercase",
  },
  buyNowButton: {
    borderRadius: 6,
    paddingBottom: 10,
    marginTop: -14,
  },
  buyNowBtn: {
    width: 120,
    height: 40,
  },
});
